import { sendEvent } from "@/utils/customLogger";
import { UserInfoData, UserQualificationData } from "@/utils/fetch";
import { ApplyProgressCode, individualApplyProgressCode, PAY_TYPE, PaymentActionType } from "../constants/organization";

export enum ActionTypes {
    /* 重点接口： 用户信息分布 */
    SHOW_USER_INFO = "SHOW_USER_INFO",
    /* 进入入驻时，曝光入驻进度 */
    SHOW_ORGANIZATION = "SHOW_ORGANIZATION",
    /* 签订协议时，上报平台技术服务费费率 */
    SHOW_COMMISSION_RATE = "SHOW_COMMISSION_RATE",
    /* 提交材料点击 */
    CLICK_QUALIFICATION_SUBMIT = "CLICK_QUALIFICATION_SUBMIT",
    /* 签订协议点击 */
    CLICK_AGREEMENT_SIGN = "CLICK_AGREEMENT_SIGN",
    /* 绑定结算账户按钮点击（立即绑定+查看详情） */
    CLICK_PAYMENT_ACTION = "CLICK_PAYMENT_ACTION",
}

/* 重点接口： 用户信息分布 */
export const loggerShowUserInfo = ({
    userInfo,
    qualification,
}: {
    userInfo: UserInfoData;
    qualification: UserQualificationData;
}) => {
    sendEvent("show", ActionTypes.SHOW_USER_INFO, {
        ...(userInfo || {}),
        ...(qualification || {}),
    });
};

/* 绑定结算账户按钮点击（立即绑定+查看详情） */
export const loggerClickPaymentAction = ({
    paymentActionType,
    payType,
}: {
    paymentActionType: PaymentActionType;
    payType: PAY_TYPE;
}) => {
    sendEvent("click", ActionTypes.CLICK_PAYMENT_ACTION, {
        paymentActionType,
        payType,
    });
};

/* 进入入驻时，曝光机构入驻进度 */
export const loggerShowOrganization = ({ applyProgress }: { applyProgress: ApplyProgressCode }) => {
    sendEvent("show", ActionTypes.SHOW_ORGANIZATION, {
        applyProgress,
    });
};

/* 进入入驻时，曝光个人入驻进度 */
export const loggerShowIndividuals = ({ applyProgress }: { applyProgress: individualApplyProgressCode }) => {
    sendEvent("show", ActionTypes.SHOW_ORGANIZATION, {
        applyProgress,
    });
};

/* 签订协议点击 */
export const loggerClickAgreementSign = ({ date, duration }: { date: number; duration: number }) => {
    sendEvent("click", ActionTypes.CLICK_AGREEMENT_SIGN, {
        date,
        duration,
    });
};

/* 签订协议时，上报平台技术服务费费率 */
export const loggerShowCommission = ({ commissionRate }: { commissionRate: number }) => {
    sendEvent("show", ActionTypes.SHOW_COMMISSION_RATE, {
        commissionRate,
    });
};

/* 提交材料点击 */
export const loggerClickQualificationSubmit = ({ date, duration }: { date: number; duration: number }) => {
    sendEvent("click", ActionTypes.CLICK_QUALIFICATION_SUBMIT, {
        date,
        duration,
    });
};
